module.exports = __webpack_public_path__ + "static/media/plants.6ec7813f.png";